import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";

const KEY = "etprime_risk_dismissed_v1";

export const RiskBanner = () => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (!sessionStorage.getItem(KEY)) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  // Reserve space at the bottom of the page equal to the banner height so the
  // fixed banner never overlaps footer content (e.g. the legal links).
  useEffect(() => {
    const apply = () => {
      const h = show && ref.current ? ref.current.offsetHeight : 0;
      document.body.style.paddingBottom = h ? `${h}px` : "";
    };
    apply();
    window.addEventListener("resize", apply);
    return () => {
      window.removeEventListener("resize", apply);
      document.body.style.paddingBottom = "";
    };
  }, [show]);

  const dismiss = () => {
    try {
      sessionStorage.setItem(KEY, "1");
    } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      ref={ref}
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#0A0D12]/95 backdrop-blur-md border-t border-[#C8A45A]/30"
      data-testid="risk-banner"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex items-start md:items-center gap-4">
        <AlertTriangle className="text-[#C8A45A] shrink-0 mt-0.5 md:mt-0" size={18} />
        <p className="text-xs text-[#A1A5AB] leading-relaxed flex-1">
          <span className="text-white font-medium">Risk warning:</span> Leveraged OTC CFDs and FX contracts are complex
          and high risk. You can lose more than your deposited margin. These products are available only to wholesale
          clients and are not suitable for everyone. ET Prime acts as principal and you are exposed to our credit risk.{" "}
          <Link to="/legal/risk-warning" className="text-[#C8A45A] underline whitespace-nowrap" data-testid="risk-banner-link">
            Read more
          </Link>
        </p>
        <button
          onClick={dismiss}
          data-testid="risk-banner-dismiss"
          aria-label="Dismiss risk warning"
          className="shrink-0 text-[#737882] hover:text-white transition-colors p-1"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default RiskBanner;
